import React, { Component } from 'react'
import { Bar } from 'react-chartjs-2'
import { format } from 'date-fns'
import { thousandSeparator } from '../../utils/Utils'
import 'chartjs-plugin-style'

class MBarChar extends Component {
  state = {
    ticks: {
      labels: [],
      datasets: [
        {
          label: '',
          fill: this.props.fill,
          lineTension: 0.1,
          backgroundColor: [
            '#ff4e44',
            '#C3AEFF',
            '#4cd964',
            '#ffcc00',
            '#006fff',
            '#FA327C',
            '#DE9203',
            '#401EFF',
          ],
          borderColor: [
            '#ff4e44',
            '#C3AEFF',
            '#4cd964',
            '#ffcc00',
            '#006fff',
            '#FA327C',
            '#DE9203',
            '#401EFF',
          ],
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: this.props.chartColor,
          pointBackgroundColor: this.props.chartColor,
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: this.props.chartColor,
          pointHoverBorderColor: this.props.chartColor,
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 8,
          data: [],
          borderWidth: 2,
          lineTension: 0,
        },
      ],
    },
  }

  componentDidMount() {
    const values = this.props.data.map(({ value }) => value)
    const sources = this.props.data.map(({ source }) => source)

    const newData = sources.map(function(d, i) {
      return {
        label: d,
        data: values[i] || 0,
      }
    })

    const sortedNewData = newData.sort((a, b) => b.data - a.data)
    sortedNewData.length = this.props.limitTicks
    const newDataLabel = []
    const newDataData = []

    sortedNewData.forEach(function(d) {
      newDataLabel.push(d.label)
      newDataData.push(d.data)
    })

    this.setState({
      ticks: {
        labels: newDataLabel,
        datasets: [
          {
            ...this.state.ticks.datasets[0],
            label: this.props.label,
            data: newDataData,
          },
        ],
      },
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      const values = this.props.data.map(({ value }) => value)
      const sources = this.props.data.map(({ source }) => source)

      const newData = sources.map(function(d, i) {
        return {
          label: d,
          data: values[i] || 0,
        }
      })

      const sortedNewData = newData.sort((a, b) => b.data - a.data)
      sortedNewData.length = this.props.limitTicks
      const newDataLabel = []
      const newDataData = []

      sortedNewData.forEach(function(d) {
        newDataLabel.push(d.label)
        newDataData.push(d.data)
      })

      this.setState({
        ticks: {
          labels: newDataLabel,
          datasets: [
            {
              ...this.state.ticks.datasets[0],
              label: this.props.label,
              data: newDataData,
            },
          ],
        },
      })
    }
  }

  render() {
    const { ticks } = this.state
    const {
      symbol,
      showLegend,
      labelFontColor,
      fontColor,
      showGridline,
      gridLinesColor,
      zeroLineColor,
    } = this.props

    const options = {
      maintainAspectRatio: false,
      legend: {
        display: showLegend,
        position: 'bottom',
        fullWidth: true,
        onClick: e => e.stopPropagation(),
        labels: {
          fontColor: labelFontColor,
          fontSize: 14,
          generateLabels: function(chart) {
            chart.legend.afterFit = function() {
              this.lineWidths = this.lineWidths.map(() => this.width - 12)

              this.options.labels.padding = 15
              this.options.labels.boxWidth = 15
            }

            const data = chart.data
            if (data.labels.length && data.datasets.length) {
              return data.labels.map(function(label, i) {
                const meta = chart.getDatasetMeta(0)
                var ds = data.datasets[0]
                var arc = meta.data[i]
                var custom = (arc && arc.custom) || {}
                var getValueAtIndexOrDefault =
                  Chart.helpers.getValueAtIndexOrDefault
                var arcOpts = chart.options.elements.arc
                var fill = custom.backgroundColor
                  ? custom.backgroundColor
                  : getValueAtIndexOrDefault(
                      ds.backgroundColor,
                      i,
                      arcOpts.backgroundColor
                    )
                var stroke = custom.borderColor
                  ? custom.borderColor
                  : getValueAtIndexOrDefault(
                      ds.borderColor,
                      i,
                      arcOpts.borderColor
                    )
                var bw = custom.borderWidth
                  ? custom.borderWidth
                  : getValueAtIndexOrDefault(
                      ds.borderWidth,
                      i,
                      arcOpts.borderWidth
                    )

                return {
                  text: label,
                  fillStyle: fill,
                  strokeStyle: stroke,
                  lineWidth: bw,
                  hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
                  index: i,
                }
              })
            }
            return []
          },
        },
      },
      scales: {
        yAxes: [
          {
            ticks: {
              min: 0,
              precision: 0,
              maxTicksLimit: 4,
              type: 'logarithmic',
              beginAtZero: false,
              fontFamily: "'Exo 2', 'Helvetica', 'Arial'",
              fontSize: 10,
              fontColor: fontColor,
              autoSkip: true,
              callback: function(value, index, values) {
                return value >= 1000 ? value / 1000 + ' тыс.' : value
              },
            },
            gridLines: {
              display: showGridline,
              color: gridLinesColor,
              zeroLineColor: zeroLineColor,
            },
          },
        ],
        xAxes: [
          {
            maxBarThickness: 90,
            ticks: {
              display: false,
              precision: 0,
              maxTicksLimit: 4,
              beginAtZero: false,
              fontFamily: "'Exo 2', 'Helvetica', 'Arial'",
              maxRotation: 0,
              minRotation: 0,
              fontColor: fontColor,
              autoSkip: true,
            },
            gridLines: {
              display: false,
              color: gridLinesColor,
              zeroLineColor: zeroLineColor,
            },
          },
        ],
      },
      tooltips: {
        caretSize: 0,
        displayColors: true,
        xPadding: 10,
        yPadding: 10,
        mode: 'label',
        intersect: true,
        titleFontFamily: "'Exo 2', 'Helvetica', 'Arial'",
        titleFontSize: 14,
        titleFontColor: '#000',
        titleFontStyle: 'normal',
        titleMarginBottom: 10,
        bodyAlign: 'left',
        bodyFontColor: '#979797',
        bodyFontSize: 12,
        bodyFontFamily: "'Exo 2', 'Helvetica', 'Arial'",
        backgroundColor: '#ffffff',
        shadowOffsetX: 0,
        shadowOffsetY: 16,
        shadowBlur: 32,
        shadowColor: 'rgba(0, 0, 0, 0.12)',
        caretPadding: 15,
        callbacks: {
          label: function(tooltipItem, data) {
            const label = data.datasets[tooltipItem.datasetIndex].label || ''
            return `${label}:  ${thousandSeparator(tooltipItem.value)} ${
              symbol ? symbol : ''
            }`
          },
        },
        hover: {
          mode: 'nearest',
          intersect: true,
        },
      },
    }

    return <Bar ref="chart" data={ticks} options={options} />
  }
}

export default MBarChar
